const CarrierEnrollKeys = {
  TITLE: "title",
  PLATFORM_NAME: "platformName",
  PARTY_ID: "carrierPartyId",
  OTHER_PLATFORM_CODE: "otherPlatformCode",
  EXCLUDES: "excludes"
}

export default CarrierEnrollKeys
